
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorSetpointIcon as ObiCursorSetpointIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-setpoint-icon.js';
 
 
 

 
 export const ObiCursorSetpointIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-setpoint-icon',
   elementClass: ObiCursorSetpointIconElement,
   events: {
     
   }
  });
 
 